import { useDeleteSurveyMutation } from "../../../../../api/surveys/useDeleteSurveyMutation";
import { SETTINGS_ROUTES } from "../../../../../consts/routes";
import { history } from "../../../../../history";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { getPathParams } from "../utilities";

export const useDelete = () => {
  const { surveyId } = getPathParams();

  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { mutateAsync, isLoading } = useDeleteSurveyMutation({
    onSuccess: () => {
      uiNotification.success(t("success.delete"));
      history.push(SETTINGS_ROUTES.surveys());
    },
    onError: () => {
      uiNotification.error(t("error.delete"));
    },
  });

  return {
    initiate: () => {
      return mutateAsync({ id: surveyId });
    },
    isLoading,
  };
};
